// import React from 'react';
// import { motion } from 'framer-motion';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import './RealEstateErp.css'; 

// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: {
//       staggerChildren: 0.1,
//     },
//   },
// };

// const letterVariants = {
//   hidden: { opacity: 0, y: 50 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: {
//       type: 'spring',
//       stiffness: 50,
//     },
//   },
// };

// const SugarErp = () => {
//   return (
//     <div className="container text-center d-flex flex-column justify-content-center align-items-center comingSooncontainer">
//       <h1 className='erp-heading'>Sugar ERP</h1>
//       <motion.div
//         initial="hidden"
//         animate="visible"
//         variants={containerVariants}
//         className="mb-10"
//       >
//         {/* {'Coming Soon'.split('').map((letter, index) => (
//           <motion.span key={index} variants={letterVariants} className="display-1">
//             {letter}
//           </motion.span>
//         ))} */}
//         <iframe src="https://lottie.host/embed/b46d86b1-7742-403e-a0cf-a7de01aaecf1/GBLeYf49xf.json" className='comingSoonIframe'></iframe>
//       </motion.div>
//       <motion.div
//         initial={{ opacity: 0, y: 50 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 1, type: 'spring', stiffness: 50 }}
//         className="lead"
//       >
//         Stay tuned, we appreciate your patience.
//       </motion.div>
//     </div>
//   );
// }

// export default SugarErp

import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SugarErp.css";
import { FaUsers, FaTruck, FaIndustry, FaChartLine, FaDatabase, FaWarehouse } from "react-icons/fa";

const SugarErp = () => {

  const features = [
    {
      icon: <FaUsers />,
      title: "Farmer Management",
      desc: "Maintain farmer records, land details and cane supply information in one place."
    },
    {
      icon: <FaTruck />,
      title: "Cane Procurement",
      desc: "Track transportation, procurement schedules and delivery status."
    },
    {
      icon: <FaIndustry />,
      title: "Production Monitoring",
      desc: "Monitor crushing operations, plant efficiency and daily production data."
    },
    {
      icon: <FaWarehouse />,
      title: "Inventory Management",
      desc: "Manage sugar stock, by-products and warehouse inventory efficiently."
    },
    {
      icon: <FaDatabase />,
      title: "Centralized Data",
      desc: "Securely store all sugar factory operational data in one ERP system."
    },
    {
      icon: <FaChartLine />,
      title: "Reports & Analytics",
      desc: "Generate detailed reports and insights for better decision making."
    }
  ];

  return (
    <div className="sugar-erp-page">

      {/* Hero Section */}
      <div className="erp-hero text-center">

        <motion.h1
          initial={{opacity:0,y:40}}
          animate={{opacity:1,y:0}}
          transition={{duration:0.6}}
        >
          Sugar ERP Solution
        </motion.h1>

        <motion.p
          initial={{opacity:0,y:40}}
          animate={{opacity:1,y:0}}
          transition={{duration:0.8}}
        >
          A complete ERP platform designed for sugar factories to manage
          farmers, cane procurement, production data, inventory and analytics
          in one integrated system.
        </motion.p>

      </div>

      {/* Features */}
      <div className="container features-section">

        <h2 className="text-center section-title">
          ERP Modules for Sugar Industry
        </h2>

        <div className="row">

          {features.map((item,index)=>(
            <motion.div
              key={index}
              className="col-md-4 mb-4"
              initial={{opacity:0,y:30}}
              whileInView={{opacity:1,y:0}}
              transition={{duration:0.5}}
            >
              <div className="feature-card">

                <div className="feature-icon">
                  {item.icon}
                </div>

                <h5>{item.title}</h5>
                <p>{item.desc}</p>

              </div>
            </motion.div>
          ))}

        </div>
      </div>

      {/* CTA Section */}

      <div className="erp-cta text-center">

        <h2>Digitize Your Sugar Factory Operations</h2>

        <p>
          Improve efficiency and manage your factory data with our
          powerful Sugar ERP solution.
        </p>

        {/* <button className="btn erp-btn">
          Request Demo
        </button> */}

      </div>

    </div>
  );
};

export default SugarErp;